export type MountedPreviewAction =
  | { type: 'play'; clipId: string }
  | { type: 'pause'; clipId: string };

/** At most one clip card may hold a live decoder. Play replaces; pause
 *  releases only if that same clip is still the active one. */
export function reduceMountedPreviewClipId(
  current: string | null,
  action: MountedPreviewAction,
): string | null {
  if (action.type === 'play') return action.clipId;
  return current === action.clipId ? null : current;
}
